import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ActiveWizardCheckIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 35 35", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <path
                    fill="#21006E"
                    d="M17.5,2.6c8.2,0,14.9,6.7,14.9,14.9s-6.7,14.9-14.9,14.9S2.6,25.7,2.6,17.5S9.3,2.6,17.5,2.6 M17.5,0.5
		c-9.4,0-17,7.6-17,17s7.6,17,17,17s17-7.6,17-17S26.9,0.5,17.5,0.5L17.5,0.5z"
                />
            </g>
            <g>
                <polygon
                    fill="#21006E"
                    points="16.8,22.5 12.5,18.3 14,16.7 16.5,19.3 20.9,13.5 22.6,14.7 	"
                />
            </g>
        </SvgIcon>
    );
};
